import _ from "@lodash";
import XAPPService from "app/Core/services/XAPPService";
import { GETCUSTOM_TAG_FUNCIONALIDADE, TagFuncionalidadeListState } from "../../../../ERP/TagFuncionalidade/Store/Actions/TagFuncionalidadeActions";
export const GET_MINHASTAREFAS = "[MINHASTAREFAS APP] GET MINHASTAREFAS";
export const GET_MINHATAREFA = "[MINHASTAREFAS APP] GET MINHATAREFA";
export const GET_FLUXO = "[MINHASTAREFAS APP] GET TAREFA FLUXO";
export const GET_MINHASTAREFAS_PESSOA = "[MINHASTAREFAS APP] GET TAREFA PESSOA";
export const MINHASTAREFAS_ERROR = "[MINHASTAREFAS APP] MINHASTAREFAS ERROR";
export const MINHASTAREFAS_WARNING = "[MINHASTAREFAS APP] MINHASTAREFAS WARNING";
export const MINHASTAREFAS_INFO = "[MINHASTAREFAS APP] MINHASTAREFAS INFO";
export const GET_MINHASTAREFAS_ATENDIMENTOS = "[MINHASTAREFAS APP] GET MINHASTAREFAS ATENDIMENTO";
export const CLEAR_ATENDIMENTOS = "[MINHASTAREFAS APP] CLEAR ATENDIMENTOS";
export const CLEAR_DISPONIBILIDADE = "[MINHASTAREFAS APP] CLEAR DISPONIBILIDADE";
export const GET_FLUXOSEMPRESA = "[MINHASTAREFAS APP] GET FLUXOS EMPRESA";
export const GET_PROFISSIONAISEMPRESA = "[MINHASTAREFAS APP] GET PROFISSIONAIS EMPRESA";
export const GET_PRODUTOSEMPRESA = "[MINHASTAREFAS APP] GET PRODUTOS EMPRESA";
export const GET_ESPECIALIDADESEMPRESA = "[MINHASTAREFAS APP] GET ESPECIALIDADES EMPRESA";
export const GET_TAREFAS_PASSADO = "[MINHASTAREFAS APP] GET TAREFAS PASSADO";
export const OPEN_NOVO_DIALOG = "[MINHASTAREFAS APP] OPEN NOVO DIALOG";

const MinhasTarefasListState = [
    "idtarefa",
    "idtarefaprocesso",
    "tipo",
    "idfluxo",
    "passofluxo",
    "passoicone",
    "formulario",
    "status",
    "prazo",
    "prazodescricao",
    "observacao",
    "tarefatag",
    "tarefaatendimentotag",
    "pessoaformulario",
    "usrins",
    "usrupt",
    "datainsdescricao",
    "datauptdescricao",
    "concluido",
    "idpessoaformulario",
    "lembrete",
    "statusfinanceiro",
    "responsaveldescricao",
    "obj"
];

const TarefasPassadoListState = [
    "idtarefa",
    "descricao",
    "prazodescricao",
    "observacao",
    "conclusao",
    "conclusaodescricao",
    "tarefatag",
    "usrins",
    "usrupt",
    "datainsdescricao",
    "datauptdescricao",
    "concluido"
];

const MinhasTarefasGetState = [
    "idtarefa",
    "idtarefaprocesso",
    "idpessoaformulario",
    "passofluxo",
    "prazo",
    "conclusao",
    "prazodescricao",
    "conclusaodescricao",
    "tipo",
    "observacao",
    "solicitante",
    "responsavel",
    "status",
    "jsonpasso",
    "idpessoa",
    "idfluxo",
    "tarefatag",
    "formulario",
    "pessoaformulario",
    "statusregistro",
    "usrins",
    "usrupt",
    "datainsdescricao",
    "datauptdescricao",
    "obj"
];

const FluxoGetState = [
    "idfluxo",
    "nome",
    "tipo",
    "jsonpasso",
    "usrins",
    "usrupt",
    "datainsdescricao",
    "datauptdescricao"
];

const ProfissionalGetState = [
    "idpessoaformulario",
    "nome"
];

const EmpresaProdutoGetState = [
    "idpessoaformulario",
    "nomevalor"
];

const EmpresaEspecialidadeGetState = [
    "idpessoaformulario",
    "nome"
];

const HistoricoPessoaFormularioListState = [
    "idtarefa",
    "conclusao",
    "prazodescricao",
    "conclusaodescricao",
    "intervalo",
    "tarefatag",
    "tarefaatendimentotag",
    "formulario",
    "responsaveldescricao"
];

const MensagemAddState = [
    "idtarefaprocesso",
    "tipo",
    "descricao",
];


export function list(_AAction, _AParams, _AFilter = null, _AParametros) {

    return (dispatch) => {

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];

        if (_AFilter !== null) {
            if (_AFilter.AND && _AFilter.AND !== null) {
                AConditionsAND = _AFilter.AND;
            }

            if (_AFilter.OR && _AFilter.OR !== null) {
                AConditionsOR = _AFilter.OR;
            }
        }

        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, _AParametros.nome, AActions, _AParametros.procedure, MinhasTarefasListState, _AAction, AConditionsAND, AConditionsOR);

        AConditionsAND = [{ "Campo": "tagfuncionalidade.tipo", "Operador": "=", "Valor": "agendamento" }];
        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "tagfuncionalidade", AActions, "spvwtagfuncionalidade", TagFuncionalidadeListState, "SELECIONAR", AConditionsAND, AConditionsOR);

        AConditionsAND = [{ "Campo": "tagfuncionalidade.tipo", "Operador": "=", "Valor": "atendimento" }];
        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "tagfuncionalidade", AActions, "spvwtagfuncionalidade", TagFuncionalidadeListState, "SELECIONAR", AConditionsAND, AConditionsOR);

        XAPPService.XappSelAction(AActions, _AParams)
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_MINHASTAREFAS,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data : "",
                    })
                    , dispatch({
                        type: GETCUSTOM_TAG_FUNCIONALIDADE,
                        Name: "agendamento",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[1].data : "",
                    })
                    , dispatch({
                        type: GETCUSTOM_TAG_FUNCIONALIDADE,
                        Name: "atendimento",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[2].data : "",
                    })
                ])
            ).catch(error => {
                return dispatch({
                    type: MINHASTAREFAS_ERROR,
                    payload: error
                });
            });
    };
}

export function get(_AID, _AParams, _AParametros) {

    return (dispatch) => {

        var AConditionsAND = [{ "Campo": "tarefa.idtarefa", "Operador": "=", "Valor": _AID }];
        var AConditionsOR = [];
        var AActions = [];

        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, _AParametros.nome, AActions, "spvwflowminhatarefa", MinhasTarefasGetState, "SELECIONAR", AConditionsAND, AConditionsOR);

        XAPPService.XappSelAction(AActions, _AParams)
            .then((response) => {
                if (JSON.parse(response.data)[0].data !== null) {
                    Promise.all([
                        dispatch({
                            type: GET_MINHATAREFA,
                            Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                            payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data[0] : "",
                        })
                    ]);
                }
            }).catch(error => {
                return dispatch({
                    type: MINHASTAREFAS_ERROR,
                    payload: error
                });
            });
    };
}

export function getTarefa(_AID, _AParams, _AParametros) {

    return (dispatch) => {

        var AConditionsAND = [
            { "Campo": "tarefa.idtarefaprocesso", "Operador": "=", "Valor": _AID },
            { "Campo": "tarefa.conclusao", "Operador": "is", "Valor": "NULL" }
        ];
        var AConditionsOR = [];
        var AActions = [];

        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, _AParametros.nome, AActions, "spvwflowminhatarefa", MinhasTarefasGetState, "SELECIONAR", AConditionsAND, AConditionsOR);

        XAPPService.XappSelAction(AActions, _AParams)
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_MINHATAREFA,
                        Name: "",
                        payload: null,
                    }),
                    dispatch({
                        type: GET_MINHATAREFA,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: (response.data && response.data.length > 0 && !_.isNull(JSON.parse(response.data)[0].data)) ? JSON.parse(response.data)[0].data[0] : null,
                    })
                ])
            ).catch(error => {
                return dispatch({
                    type: MINHASTAREFAS_ERROR,
                    payload: error
                });
            });
    };
}

export function getFluxo(_AAction, _AParams, _ATipo, _AIDPessoa, _AData = null, _AIDFluxo = null) {

    return (dispatch) => {

        var AConditionsAND = [
            { "Campo": "fluxo.tipo", "Operador": "IN", "Valor": "(" + _ATipo + ")" },
            { "Campo": "fluxo.statusregistro", "Operador": "=", "Valor": 1 }
        ];
        var AConditionsOR = [];
        var AActions = [];

        if (_AIDFluxo !== null) {
            AConditionsAND.push({ "Campo": "fluxo.idfluxo", "Operador": "=", "Valor": _AIDFluxo });
        }

        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "fluxo", AActions, "spvwfluxo", FluxoGetState, _AAction, AConditionsAND, AConditionsOR);
        XAPPService.XappSelAction(AActions, _AParams, "SEL")
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_MINHATAREFA,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: (response.data && response.data.length > 0 && JSON.parse(response.data)[0].data !== null) ?
                            { ...JSON.parse(response.data)[0].data[0], passofluxo: 1, data: _AData, formulario: {} } :
                            {},
                    })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: MINHASTAREFAS_ERROR,
                    payload: error
                });
            });
    };
}

export function clearMinhasTarefas() {
    return {
        type: GET_MINHASTAREFAS,
        payload: null
    };
}

export function clearFluxo() {
    return {
        type: GET_FLUXO,
        payload: null
    };
}

export function clearMinhaTarefa() {
    return {
        type: GET_MINHATAREFA,
        payload: null
    };
}

export function clearDisponibilidade() {
    return {
        type: CLEAR_DISPONIBILIDADE,
        fluxodisponibilidade: null
    };
}

export function clearAtendimentos() {
    return {
        type: CLEAR_ATENDIMENTOS,
        atendimentos: null
    };
}

export function getAtendimentos(_AAction, _AParams, _AForm) {

    return (dispatch) => {

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];

        AConditionsAND = [{ "Campo": "idpessoaformulario", "Operador": "=", "Valor": _AForm.idpessoaformulario },
        { "Campo": "passofluxo", "Operador": "=", "Valor": _AForm.passofluxo },
        { "Campo": "idtarefa", "Operador": "=", "Valor": _AForm.idtarefa }];
        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "HistoricoPessoaFormulario", AActions, "spvwhistoricopessoaformulario", HistoricoPessoaFormularioListState, _AAction, AConditionsAND, AConditionsOR);

        XAPPService.XappSelAction(AActions, _AParams)
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_MINHASTAREFAS_ATENDIMENTOS,
                        atendimentos: (response.data && response.data !== null && response.data.length > 0) ? JSON.parse(response.data)[0].data : "",
                    }),
                ])
            )
            .catch(error => {
                return dispatch({
                    type: MINHASTAREFAS_ERROR,
                    payload: error
                });
            });
    };
}

export function getFluxosEmpresa(_AParams, _AParametros) {

    return (dispatch) => {
        if (_.isUndefined(_AParametros.tipo) || _.isNull(_AParametros.tipo)) {
            return dispatch({
                type: GET_FLUXOSEMPRESA,
                payload: null
            });
        }

        var AActions = [];
        var AConditionsOR = [];
        var AConditionsAND = [];

        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "ProfissionaisEmpresa", AActions, "spvwempresapessoafuncionarioatendimento", ProfissionalGetState, "SELECIONAR", AConditionsAND, AConditionsOR);

        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "ProdutosEmpresa", AActions, "spvwempresaproduto", EmpresaProdutoGetState, "SELECIONAR", AConditionsAND, AConditionsOR);

        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "EspecialidadesEmpresa", AActions, "spvwempresaproduto", EmpresaEspecialidadeGetState, "SELECIONAR", AConditionsAND, AConditionsOR);

        XAPPService.XappSelAction(AActions, _AParams, "SEL")
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_PROFISSIONAISEMPRESA,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data : "",
                    }),
                    dispatch({
                        type: GET_PRODUTOSEMPRESA,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[1].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[1].data : "",
                    }),
                    dispatch({
                        type: GET_ESPECIALIDADESEMPRESA,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[2].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[2].data : "",
                    })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: MINHASTAREFAS_ERROR,
                    payload: error
                });
            });
    };
}

export function enviarMensagem(_AValue, _AParams) {
    return (dispatch) => {

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];

        AActions = XAPPService.XappDoActionFactory(_AParams.empresa, AActions, "tarefaprocessoatividade", "INSERIR", _AValue, "", AConditionsAND, AConditionsOR, 1, MensagemAddState);

        XAPPService.XappDoAction(AActions, _AParams, "DO")
            .then((response) => {
                if (response.warning) {
                    Promise.all([
                        dispatch({
                            type: MINHASTAREFAS_WARNING,
                            payload: response.warning
                        })
                    ]);
                }
                else if (response.info) {
                    Promise.all([
                        dispatch({
                            type: MINHASTAREFAS_INFO,
                            payload: response.info
                        })
                    ]);
                }
            }
            ).catch(error => {
                return dispatch({
                    type: MINHASTAREFAS_ERROR,
                    payload: error
                });
            });
    };
}

export function getTarefasPassado(_AIDProcesso, _AIDTarefa, _AParams) {

    return (dispatch) => {

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];

        AConditionsAND = [{ "Campo": "tarefa.idtarefa", "Operador": "<", "Valor": _AIDTarefa }];
        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "TarefasPassado", AActions, "spvwtarefa", TarefasPassadoListState, "SELECIONAR", AConditionsAND, AConditionsOR);

        XAPPService.XappSelAction(AActions, _AParams)
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_TAREFAS_PASSADO,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data : "",
                        idtarefa: _AIDTarefa,
                    })
                ])
            ).catch(error => {
                return dispatch({
                    type: MINHASTAREFAS_ERROR,
                    payload: error
                });
            });
    };
}

export function clearTarefasPassado(_AID) {
    return {
        type: GET_TAREFAS_PASSADO,
        idtarefa: _AID,
        payload: null
    };
}

export function saveTarefa(_ATarefa, _AParams, _ACallback = null) {
    return (dispatch) => {

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];

        AActions = XAPPService.XappFlowActionFactory(_AParams.empresa, AActions, "tarefa", "EXECUTARACAO", _ATarefa, "", AConditionsAND, AConditionsOR);
        XAPPService.XappFlowAction(AActions, _AParams)
            .then((response) => {
                if (response.warning) {
                    Promise.all([
                        dispatch({
                            type: MINHASTAREFAS_WARNING,
                            payload: response.warning
                        })
                    ]);
                    if (!_.isNull(_ACallback)) {
                        _ACallback();
                    }
                }
                else if (response.info) {
                    Promise.all([
                        dispatch({
                            type: MINHASTAREFAS_INFO,
                            payload: response.info
                        })
                    ]);
                    if (!_.isNull(_ACallback)) {
                        _ACallback();
                    }
                }
            }
            ).catch(error => {
                return dispatch({
                    type: MINHASTAREFAS_ERROR,
                    payload: error
                });
            });
    };
}

export function openNovoDialog(_AValue) {
    return {
        type: OPEN_NOVO_DIALOG,
        payload: _AValue

    };
}
